import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import '@fontsource/saira/400.css'
import '@fontsource/saira/500.css'
import '@fontsource/saira/600.css'
import '@fontsource/saira/700.css'
import '@fontsource/saira/800.css'
import '@fontsource/saira/900.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import './index.css'
import { i18nReady } from './i18n';
import { initAnalytics } from './lib/analytics';
import { dropStaleChunkEvent, installStaleChunkReload } from './lib/chunkReload';
import { offlineQueryCache } from './lib/offlineQueryCache';
import { seedTeamDetailsFromLists } from './lib/offlineTeamReads';
import { queryClient } from './lib/queryClient';
import { registerServiceWorker } from './features/pwa/registerServiceWorker';

installStaleChunkReload();
initAnalytics();
if (offlineQueryCache) {
  offlineQueryCache.start();
  seedTeamDetailsFromLists(queryClient);
  void offlineQueryCache.restore();
}
// The dev server has no /sw.js.
if (import.meta.env.PROD) void registerServiceWorker({ enabled: import.meta.env.VITE_PWA === 'true' });

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
    sendDefaultPii: false,
    // The page is already reloading onto the new build; the stale-chunk error is not a bug.
    beforeSend: dropStaleChunkEvent,
  });
}

const root = document.getElementById('app');
if (!root) throw new Error('Root element #app not found');

// A language other than French loads on demand: rendering before it would flash French first.
// The wait is capped in i18n.ts, past which French shows.
void i18nReady.finally(() => {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
